import React from "react";
import { useTranslation } from "react-i18next";
import { LangLink } from "../../utils/langNavigation";
import "./NotFound.scss";

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="not-found-page">
      <p className="not-found-code">404</p>

      <h1 className="not-found-heading">
        {t("notFound_heading.other")}
      </h1>

      <hr className="not-found-divider" aria-hidden="true" />

      <p className="not-found-subtext">
        {t("notFound_subtext.other")}
      </p>

      <div className="not-found-destinations">
        <LangLink to="/" className="not-found-link">
          {t("notFound_homepage.other")}
        </LangLink>
      </div>
    </div>
  );
};

export default NotFound;
